import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  error: '',
  actionsloading: false,
  pdf: {
    actionsloading: false,
    byId: {},
    pdfObj: {},
  },
});

export function subscribedUserReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SAVE_SUBSCRIBED_USER:
    case actionTypes.UPDATE_SUBSCRIBED_USER:
    case actionTypes.GET_SUBSCRIBED_USER:
    case actionTypes.GET_SUBSCRIBED_USERS:
    case actionTypes.DELETE_SUBSCRIBED_USER:
    case actionTypes.GET_PDFS:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GENERATE_PDF:
    case actionTypes.DELETE_PDF:
      return {
        ...state,
        pdf: {
          ...state.pdf,
          pdfObj: {},
          actionsloading: true,
        },
        error: '',
      };
    case actionTypes.GET_PDFS_SUCCESS:
      return {
        ...state,
        pdf: {
          ...state.pdf,
          byId: action.payload.byId || {},
          actionsloading: false,
        },
        actionsloading: false,
      };
    case actionTypes.GENERATE_PDF_SUCCESS:
    case actionTypes.GET_PDF_STATUS_SUCCESS:
      return {
        ...state,
        pdf: {
          ...state.pdf,
          actionsloading: false,
          byId: {
            ...state.pdf.byId,
            [action.payload.connections_pdfUid]: action.payload,
          },
          pdfObj: action.payload,
        },
        error: '',
        actionsloading: false,
      };
    case actionTypes.GENERATE_PDF_FAILED:
      return {
        ...state,
        pdf: {
          ...state.pdf,
          actionsloading: false,
        },
        error: action.payload,
        actionsloading: false,
      };
    case actionTypes.GET_SUBSCRIBED_USERS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false,
      };
    case actionTypes.SAVE_SUBSCRIBED_USER_SUCCESS:
    case actionTypes.UPDATE_SUBSCRIBED_USER_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.subscribedusersUid]: action.payload,
        },
        // byId: { ...state.byId, ...action.payload.byId },
        actionsloading: false,
      };
    case actionTypes.SAVE_SUBSCRIBED_USER_FAILED:
      return {
        ...state,
        error: action.payload,
        actionsloading: false,
      }
    case actionTypes.DELETE_SUBSCRIBED_USER_SUCCESS:
      Object.keys(state.byId).forEach(function (key, index) {
        if (state.byId[key].subscribedusersUid === action.payload.id) {
          delete state.byId[key];
        }
      });
      return {
        ...state,
        byId: state.byId,
        actionsloading: false,
      };
    case actionTypes.DELETE_PDF_SUCCESS:
      Object.keys(state.pdf.byId).forEach(function (key, index) {
        if (state.pdf.byId[key].connections_pdfUid === action.payload.id) {
          delete state.pdf.byId[key];
        }
      });
      return {
        ...state,
        pdf: {
          byId: state.pdf.byId,
          pdfObj: {},
          actionsloading: false,
        },
        actionsloading: false,
      };

    default:
      return state;
  }
}
